// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/scripts/bundle." + {"83":"be18910874f099b4b69a","327":"c88c1e562e7d99ac1429","662":"53711563a9af86eff92c","678":"32132c94852187f654ad"}[chunkId] + ".js";
};